import { render, staticRenderFns } from "./CartLineDesktop.vue?vue&type=template&id=363162b4&scoped=true"
import script from "./CartLineDesktop.vue?vue&type=script&lang=js"
export * from "./CartLineDesktop.vue?vue&type=script&lang=js"
import style0 from "./CartLineDesktop.vue?vue&type=style&index=0&id=363162b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363162b4",
  null
  
)

export default component.exports